import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import { CountryService } from "../../services/country.service";
import { countryActions } from "./country.actions";

@Injectable()
export class CountryEffect {

    private readonly action$ = inject(Actions);
    private readonly countryService = inject(CountryService);

    loadCountryFromApi$ = createEffect(() => {
        return this.action$.pipe(
            ofType(countryActions["[Country-API]LoadCountry"]),
            switchMap((payload) => this.countryService.getCountries(payload.payload).pipe(
                map(countryResponse => countryActions["[Country-API]LoadSuccess"](countryResponse)),
                catchError((countryResponse) => of(countryActions["[Country-API]LoadFailed"](countryResponse)))
            ))
        )
    })

    // createCountryFromApi$ = createEffect(() => {
    //     return this.action$.pipe(
    //         ofType(countryActions["[Country-API]CreateCountry"]),
    //         switchMap((payload) => this.countryService.(payload.payload).pipe(
    //             mergeMap(res => this.countryService.getEventById(<any>res.data?.id)),
    //             map(countryResponse => countryActions["[Country-API]EventCreated"](countryResponse)),
    //             catchError((countryResponse) => of(countryActions["[Country-API]EventCreatedFailed"](countryResponse)))
    //         ))
    //     )
    // })

    // updateCountryFromApi$ = createEffect(() => {
    //     return this.action$.pipe(
    //         ofType(countryActions["[Country-API]updateEvent"]),
    //         switchMap((payload) => this.countryService.updateEvent(payload.payload).pipe(
    //             mergeMap(() => this.countryService.getEvents()),
    //             map((countryResponse) => countryActions["[Country-API]EventUpdated"](countryResponse)),
    //             catchError(() => of(countryActions["[Country-API]EventUpdatedFailed"]()))
    //         ))
    //     )
    // })

    // deleteCountryFromApi$ = createEffect(() => {
    //     return this.action$.pipe(
    //         ofType(countryActions["[Country]-API]deleteEvent"]),
    //         switchMap((payload) => this.countryService(payload.payload).pipe(
    //             map(countryResponse => countryActions["[Country-API]EventUpdated"](countryResponse)),
    //             catchError((countryResponse) => of(countryActions["[Country-API]EventUpdatedFailed"](countryResponse)))
    //         ))
    //     )
    // })
}